// extracted by mini-css-extract-plugin
export var fileUpload = "_fq-1";
export var modalButton = "_fq-0";